import { useContext } from "react";
import {
  useGetUserProfileQuery,
  useUpdateFocusedViewToggleMutation,
} from "../../../redux/api/BaseApi";
import { IUserProfile } from "../../../types/User/IUserProfile";
import { RevUserContext, RevUserContextType } from "../../../context/UserContext";
import { useReduxDispatch, useReduxSelector } from "../../../redux/hooks";
import { updateToggleState } from "../../../slices/RightBarSlice";
import { ToggleState } from "../../RightBar/RightBar";
import { setIframeLoaded, updateIframeSrc } from "../../../slices/RevelationSlice";
import { nanoid } from "nanoid";
import RevelationIframe from "../../Revelation/RevelationIframe";
import { FavoriteApi } from "../../../redux/api/FavoriteApi";

interface IIconImg {
  src: string;
  alt: string;
  title: string;
}

const FocusedViewToggle = () => {
  const { profile: preData } = useContext<RevUserContextType>(RevUserContext);
  const { data } = useGetUserProfileQuery();
  const src = useReduxSelector(s => s.revI.currentIframeSrc);
  const postData = data ? data : preData;
  const [updateFocusedViewToggle] = useUpdateFocusedViewToggleMutation();
  const dispatch = useReduxDispatch();
  const { profile } = useContext<RevUserContextType>(RevUserContext)
  const { data: config } = FavoriteApi.useGetFavoriteConfigQuery(data?.Uid, { skip: !profile?.Features?.Revelations });
  const sendMessageToIframe = (collapse: boolean) => {
    console.log('sendMessageToIframe', collapse, window["RevelationIframe"])
    window["RevelationIframe"].postMessage(collapse ? 'FocusMode_On' : 'FocusMode_Off', '*');
  }
  const maximize: IIconImg = {
    src: "./images/button_maximize.png",
    alt: "maximize",
    title: "Expanded View",
  };
  const minimize: IIconImg = {
    src: "./images/button_minimize.png",
    alt: "minimize",
    title: "Focused View",
  };
  const iconImg: IIconImg = postData.Nav_Collapsed ? maximize : minimize;
  return (
    <button
      className="bg-[#868586] grid place-content-center z-50 w-[30px] h-[30px]"
      onClick={async () => {
        try {
          // let foundINdex = config.Page_State_Xml.indexOf(
          //   '<item key="0" value="True" />'
          // );
          // let currentState = ToggleState.Uninitialized;

          !postData.Nav_Collapsed
            ? dispatch(updateToggleState(ToggleState.Collapsed))
            : dispatch(updateToggleState(ToggleState.Uninitialized));
          // const payload = await updateFocusedViewToggle(!data.Nav_Collapsed).unwrap();
          await updateFocusedViewToggle(!postData.Nav_Collapsed);
          // console.log("fulfilled", payload);

          //Just send a message to the homepage, no need to reload.
          sendMessageToIframe(!postData.Nav_Collapsed);

          //Refresh current page in IFrame because the left bar may have collapsed
          //dispatch(updateIframeSrc(null));
        } catch (error) {
          console.log("error", error);
        }
      }}
      title={iconImg.title}
    >
      <img
        className="p-1"
        src={iconImg.src}
        alt={iconImg.alt}
        width={23}
        title={iconImg.title}
      />
    </button>
  );
};
export default FocusedViewToggle;
